// Called by : src/App.vue (modal-about)

<template>
  <base-modal ref="base-modal" pageId="pge_about" pageClass="infos" modalClass="modal-md" modalDataBack="true" modalDataKey="true">

      <template #header>
        <h4 class="modal-title" id="pge_about_title">{{ $t('infos.aboutTitle') }}</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </template>

      <template #body>
        <div class="" style="font-size: 1.2em; text-align: center;">
          <p class="pr-4 ">
            <img :src="constants.assets.logoInformatVertPngFile" :alt="constants.project.name" style="max-width: 360px;" @click="setInit()">
          </p>
            <h4>{{ constants.project.name }} {{ constants.project.version }} </h4>
          <p>
            <a :href="constants.project.emailLink">{{ constants.project.emailName }}</a><br>
            <a :href="constants.project.webLink" target="_blank">{{ constants.project.webName }}</a>
          </p>
        </div>
      </template>

      <template #footer>
        <button id="btn_about_close" type="submit" class="btn btn-secondary btn-lg btn-block" data-dismiss="modal">
          <span class="oi oi-x mr-2"></span>
          {{ $t('modals.close') }}
        </button>
      </template>

  </base-modal>
</template>

<script>
import { constants } from '@/constants'
import Model from '@/model/Model'
import BaseModal from '@/components/BaseModal'

export default {
  data () {
    return {
      model: null,
    }
  },
  components: {
    BaseModal,
  },
  methods: {
    setInit() {
      // console.log('setInit');
      this.model = new Model();
      var recId = localStorage.getItem("user-rec-id") || "";
      var thisUser = this.$store.state.user.recordId || "" ; 
      // console.log('recId', recId);
      // console.log('thisUser', thisUser);
      // if (recId && !thisUser) { console.log('OKY') } else { console.log('NOP') }
      if (recId && !thisUser) {
        this.model.setUserTokens("","","").then(
        (requestSuccess) => { 
          localStorage.removeItem("user-rec-id") ; 
          document.getElementById('btn_about_close').click();
          document.getElementById('submit').click();
          // location.origin.reload(); 
        },
        (requestError) => { console.error('setUserTokens : error', requestError) }
        );
      }
    }, // setInit
  },
  computed: {
    constants() {
      return constants
    },
  },
  mounted: function() {
    // console.log('localStorage',localStorage);
  },
}
</script>

<style scoped>
  /* void */
</style>



// WEBPACK FOOTER //
// src/components/misc/ModalAbout.vue